import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  // Navigate,
  // Link,
} from "react-router-dom";

import Footer from './Components/Footer';

import CustomerHome from './Pages/Customer/Home';
import LandingPage from './Pages/Customer/LandingPage';
import CustomerBooking from './Pages/Customer/Booking';
import CustomerInspection from './Pages/Customer/Inspection';
import Terms from './Pages/Customer/Terms';
import SalesHome from './Pages/Sales/Home';
import SiteUsage from './Pages/Customer/SiteUsage';
import InspectionHome from './Pages/Customer/InspectionHome';


function App() {
  const globalServiceTypes = [
    
    {
      key: "ac-qd",
      label: "AC Quarterly Disinfection",
      description: "Premium AC Disinfection for UAE homes — eliminating mold, bacteria, and allergens from your AC system using hospital-grade, non-toxic products. Verified by our in-house microbiologists to ensure a truly healthier indoor environment.",
      image_url: "qd-banner.jpg",
      read_more_link : "https://saniacservice.com/",
      type: ['service'],
      category: 'Air',
      order:1,
      inspection_duration: null,
    },
     {
      key: "sanihome",
      label: "AC Cleaning & Disinfection",
      description: "Premium AC Disinfection for UAE homes — eliminating mold, bacteria, and allergens from your AC system using hospital-grade, non-toxic products. Verified by our in-house microbiologists to ensure a truly healthier indoor environment.",
      image_url: "qd-banner.jpg",
      read_more_link : "https://saniacservice.com/",
      type: ['inspection'],
      category: 'Air',
      order:2,
      inspection_duration: '45-60 mins',
    },
    {
      key: "gpc",
      label: "General Pest Control",
      description: "Effective pest control designed to eliminate ants, cockroaches, and other common pests from your home. Our expert team uses proven treatments to ensure your space stays pest-free, safe, and comfortable for your family.",
      image_url: "gpc-banner.jpg",
      read_more_link : "https://saniex.com/",
      type: ['service',
        // 'inspection'
        ],
      category: 'Surface',
      order:3,
      inspection_duration: '45-60 mins',
    },
   /* {
      key: "rodent",
      label: "Rodent Control",
      description: "Our expert team uses proven treatments to ensure your space stays pest-free, safe, and comfortable for your family.",
      image_url: "gpc-banner.jpg"
    } */
    {
      key: "sanih2o",
      label: "Water Tank Disinfection",
      description: "The Water Tank Disinfection service sanitizes tanks using a chemical-free and eco-friendly Swiss disinfectant. It cleans, disinfects, and deodorizes the tank surfaces leaving absolutely no residues, without contaminating the quality of your water.",
      image_url: "water-banner.jpg",
      read_more_link : "https://sanih2o.com/",
      type: ['service',
        // 'inspection'
        ],
      category: 'Water',
      order:4,
      inspection_duration: '45-60 mins',
    },
    
    
  ];

  return (
    <div className="w-full h-screen flex flex-col">

      <BrowserRouter>
        <div className="flex-1">
          <Routes>
            <Route exact path="/"
              element={<LandingPage
                globalServiceTypes={globalServiceTypes}
              />} />
            <Route exact path="/home" element={<CustomerHome
              globalServiceTypes={globalServiceTypes}
            />} />

            <Route
              path="/:service_type"
              element={
                <CustomerBooking globalServiceTypes={globalServiceTypes} />
              }
            />
             <Route exact path="/inspection" element={<InspectionHome
              globalServiceTypes={globalServiceTypes}
            />} />
              <Route
              path="/inspection/:service_type"
              element={
                <CustomerInspection globalServiceTypes={globalServiceTypes} />
              }
            />


            <Route exact path="/terms" element={
              <Terms 
               globalServiceTypes={globalServiceTypes}
            />} />
            <Route exact path="/site-usage" element={
              <SiteUsage
               globalServiceTypes={globalServiceTypes}
                />} />
            <Route path="/admin" element={<SalesHome />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
      <script async data-id="101475644" src="//static.getclicky.com/js"></script>
      <noscript><p><img alt="Clicky" width="1" height="1" src="//in.getclicky.com/101475644ns.gif" /></p></noscript>
    </div>
  );
}

export default App;
